/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentList = {
    type: 'array',
    contains: {
        type: 'TournamentMinimal',
    },
} as const;
